
<iframe [style.height]="innerHeight" id="PluginFinanceIframe" style="width: 100%;" [src]="certurl | safe" title="Plugin Finance"></iframe>
